import axios from 'axios';
import { urlStates } from '../utils';

export const apiState = axios.create({
    baseURL: `${urlStates}`
});